import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import type { OfferItem } from '@core/offers-types';
import { EMPTY_CELL, ExpandableCellComponent } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { LocationAddressCellComponent } from '../location-address-cell/location-address-cell.component';
import { OfferColumnId } from '../offer-columns';

const componentFactory = (row: OfferItem) => {
  const t = injectTranslate();
  const maxLocations = 4;
  const all = row.locations ?? [];
  const short = all.slice(0, maxLocations);

  if (!short.length) return EMPTY_CELL;

  return componentOutletConfigFactory(ExpandableCellComponent, {
    inputs: {
      id: row.id,
      group: 'locations',
      columnId: 'location',
      all,
      allLength: all.length,
      short,
      shortLength: short.length,
      componentOutletConfigFactory: (isExpanded: boolean) =>
        componentOutletConfigFactory(
          LocationAddressCellComponent,
          isExpanded ? { inputs: { locations: all } } : { inputs: { locations: short } },
        ),
      expandLabel: t('app.offers.table.cell_expand.job_location_address.show_all', {
        count: all.length - short.length,
      }),
      collapseLabel: t('app.offers.table.cell_expand.job_location_address.show_less'),
    },
  });
};

export const locationColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.LocationAddress,
  label: injectTranslate()('app.offers.table.job_location_address'),
  visible: true,
  geometry: {
    width: 200,
    minWidth: 100,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) => componentFactory(row),
}));
